<template>
	<Layout>
		<div class="container-sm mt-3">
			<div class="row">
				<div class="col-xl-4">
					<div class="column">
						<!--Profile card-->
						<div class="col ">
							<div class="card profile">
								<div class="card-body">
									<center><img src="/design/sigofood-images/user.png" class="user d-flex "></center>
										  
									<h5 class="texts">{{user.firstname}} {{user.lastname}}</h5>
									<p class="text-muted texts">{{user.mobile}}</p>
									<p class="text-muted texts">{{user.email}}</p>
								</div>

							</div>
						</div><br>

						<!--Options-->
						<div class="col profile-card">
							<div class="card profile">
								<div class="card-body">                          
									<ul class="nav flex-column" role="tablist">
										<li class="nav-item" role="presentation">
											<a href="#" class="nav-link active text-dark" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-content" role="tab" @click="clearForm()">
												<div class="row">
													<div class="col-1">
														<img src="/design/sigofood-images/profile.png" style="height: 30px; width: 30px;">
													</div>
													<div class="col">
														<span class="account" data-tab-value="#tab_1">Profile</span>
													</div>
												</div>
												<br>
											</a>
										</li>
										<li class="nav-item" role="presentation">
											<a href="#" class="nav-link text-dark" id="address-tab" data-bs-toggle="tab" data-bs-target="#address-content" role="tab"  @click="clearForm()">
												<div class="row">
													<div class="col-1">
														<img src="/design/sigofood-images/address.png" style="height: 30px; width: 30px;">
													</div>
													<div class="col">
														<span class="account" data-tab-value="#tab_2">Address</span>
													</div>
												</div><br>
											</a>
										</li>
										<li class="nav-item" role="presentation">
											<a href="#" class="nav-link text-dark" id="email-tab" data-bs-toggle="tab" data-bs-target="#email-content" role="tab">
												<div class="row"  @click="clearForm()">
													<div class="col-1">
														<img src="/design/sigofood-images/email.png" style="height: 30px; width: 30px;">
													</div>
													<div class="col">
														<span class="account" data-tab-value="#tab_3">Email ID</span>
													</div>
												</div><br>
											</a>
										</li>
										<li class="nav-item" role="presentation">
											<a href="#" class="nav-link text-dark" id="password-tab" data-bs-toggle="tab" data-bs-target="#password-content" role="tab"  @click="clearForm()">
												<div class="row">
													<div class="col-1">
														<img src="/design/sigofood-images/password.png" style="height: 30px; width: 30px;">
													</div>
													<div class="col">
														<span class="account" data-tab-value="#tab_4">Password</span>
													</div>
												</div>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
						  
					</div>
				</div>

				<!--tab content-->
				<div class="col-xl">              
					<div class="tab-content">
						<div class="tab-pane active" id="profile-content" role="tabpanel" aria-labelledby="profile-tab">
							<div class="col">
								<div class="card profile">
									<div class="card-body">
										<h5 class="heading">Profile</h5>
										<div class="profile-section">
											<p class="text-muted">First Name</p>
											<div class="mb-3">
												<input type="text" class="form-control form-control-sm"  v-model="user.firstname" @keypress="alphaSpacesOnly" v-bind:class="{ 'is-invalid': Boolean(errors.firstname && errors.firstname.length) }">
												<div v-for="(val, index) in errors.firstname" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>
											<p class="text-muted">Last Name</p>
											<div class="mb-3">
												<input type="text" class="form-control form-control-sm"  v-model="user.lastname" @keypress="alphaSpacesOnly" v-bind:class="{ 'is-invalid': Boolean(errors.lastname && errors.lastname.length) }">
												<div v-for="(val, index) in errors.lastname" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>
											
											<p class="text-muted">Mobile Number</p>
											<div class="mb-3">
												<input type="text" class="form-control form-control-sm"  v-model="user.mobile" @keypress="numbersOnly" v-bind:class="{ 'is-invalid': Boolean(errors.mobile && errors.mobile.length) }">
												<div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>
											<div>
												<input type="button" value="Update" @click="profileUpdate()" class="right">
											</div>
													 
										</div>
 
									</div>
								</div>
							</div>
						</div>
						<!-- end of #profile-content -->

						<div class="tab-pane" id="address-content" role="tabpanel" aria-labelledby="address-tab">
							<div class="col" v-if="!is_add">
								<div class="card profile">
									<div class="card-body">
										<h5 class="heading">Address</h5>
										<div ><br>
										  	<div  v-for = "(address) in addresses"  :key="address.address_id">
												<div class="address">
													<h6>  {{user.firstname}} {{user.lastname}}</h6>
													<p class="text-muted">{{address.flat}}<br>{{address.building_no}},{{address.block}}, {{address.area}}, {{address.road_no}}<br>Mobile:  {{address.mobile}}</p>
												</div><br>
												<div class="row">
													<div class="col-sm-2 text-center  edit">
														<span data-tab-value="#tab_5" @click="is_add=true, is_edit=true, SetEditAddress(address)" >Edit</span>
													</div>
														  
													<div class="col-sm-3 text-center  edit">
														<a><p><span @click="remove(address.address_id)">Remove</span></p></a>
													</div>
												</div>
											</div>
											<hr>

										  	<div>
												<input type="button" value="Add" @click="is_add=true" class="right">
											</div>
											
										</div>
												
									</div>
								</div>
							</div>

							<div class="col" v-else>
								<div class="card profile">
									<div class="card-body">
										<div ><br>
									  		<div class="profile-section">
												<b-input-group class="mt-3 input-location">
														  
													<template #append>
														<b-button class="deliver-here ms-3 py-3 px-4" v-b-modal.location>Go</b-button>
													</template>
													<GmapAutocomplete @place_changed="setPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search your location here.." :value="location" v-bind:class="{ 'is-invalid': Boolean((errors.latitude && errors.latitude.length) || (errors.longitude && errors.longitude.length)) }"/>
												</b-input-group>
												<div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>	
													<div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>	   
												<br>
												
												<p class="text-muted">Area</p>
												<div class="mb-3">
													<input type="text" class="form-control form-control-sm" v-model="address.area"  v-bind:class="{ 'is-invalid': Boolean(errors.area && errors.area.length) }">  
													<div v-for="(val, index) in errors.area" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>		  
												</div>

												<p class="text-muted">Block Number</p>
												<div class="mb-3">
													<input type="text" class="form-control form-control-sm" v-model="address.block"  v-bind:class="{ 'is-invalid': Boolean(errors.block && errors.block.length) }">
													<div v-for="(val, index) in errors.block" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>			
												</div>

												<p class="text-muted">Road Number</p>
												<div class="mb-3">
													<input type="text" class="form-control form-control-sm" v-model="address.road_no"  v-bind:class="{ 'is-invalid': Boolean(errors.road_no && errors.road_no.length) }">
													<div v-for="(val, index) in errors.road_no" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>			
												</div>

												<p class="text-muted">Building Number</p>
												<div class="mb-3">
													<input type="text" class="form-control form-control-sm" v-model="address.building_no" v-bind:class="{ 'is-invalid': Boolean(errors.building_no && errors.building_no.length) }">
													<div v-for="(val, index) in errors.building_no" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>			  
												</div>

												<p class="text-muted">Landmark</p>
												<div class="mb-3">
													<input type="text" class="form-control form-control-sm" v-model="address.landmark" v-bind:class="{ 'is-invalid': Boolean(errors.landmark && errors.landmark.length) }">
													<div v-for="(val, index) in errors.landmark" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>

												<p class="text-muted">Flat</p>
												<div class="mb-3">
													<input type="text" class="form-control form-control-sm" v-model="address.flat" v-bind:class="{ 'is-invalid': Boolean(errors.flat && errors.flat.length) }">
													<div v-for="(val, index) in errors.flat" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>			 
												</div>

												<p class="text-muted">Mobile Number</p>
												<div class="mb-3">
													<input type="text" class="form-control form-control-sm" v-model="address.mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile && errors.mobile.length) }">
													<div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>			 
												</div>

												<div>
													<span v-if="is_edit">
														<input type="button" value="Update" @click="editAddress()"  class="right">
													</span>
													<span v-else>
														<input type="button" value="Save" @click="addAddress()"  class="right">
													</span>											
												</div><br>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- end of #profile-content -->

						<div class="tab-pane" id="email-content" role="tabpanel" aria-labelledby="email-tab">
							<div class="col">
								<div class="card profile">
									<div class="card-body">
										<h5 class="heading">Change Email</h5>
										<div class="profile-section">
											<p class="text-muted">New Email ID</p>
											<div class="mb-3">
												<input type="text" class="form-control form-control-sm"  v-model="email" v-bind:class="{ 'is-invalid': Boolean(errors.email && errors.email.length) }">
												<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
												</div>
											</div>
											
											<div class="text-box" style="position: relative;">
												<p class="text-muted">Password</p>
												<input class="form-control login_subtexts" type="text" placeholder="" v-model="password" v-if="show_password"  v-bind:class="{ 'is-invalid': Boolean(errors.password && errors.password.length) }">
												<input class="form-control login_subtexts" type="password" placeholder="" v-model="password" v-else  v-bind:class="{ 'is-invalid': Boolean(errors.password && errors.password.length) }">
												<i class="material-icons eye" v-if="show_password" @click="togglePassword()">visibility</i>
												<i class="material-icons eye" v-else @click="togglePassword()">visibility_off</i>

												<div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
												</div>
											</div>     
											<div>
												<input type="button"   @click="changeEmail()" value="Submit" class="right mt-3">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- end of #email-content -->

						<div class="tab-pane" id="password-content" role="tabpanel" aria-labelledby="password-tab">
							<div class="col">
								<div class="card profile">
									<div class="card-body">
										<h5 class="heading">Change Password</h5>
										<div class="profile-section">
											
											<div class="text-box" style="position: relative;">
												<p class="text-muted">Current Password</p>
												<input class="form-control login_subtexts" type="text" placeholder="" v-model="current_password" v-if="show_password"  v-bind:class="{ 'is-invalid': Boolean(errors.current_password && errors.current_password.length) }">
												<input class="form-control login_subtexts" type="password" placeholder="" v-model="current_password" v-else v-bind:class="{ 'is-invalid': Boolean(errors.current_password && errors.current_password.length) }">
												<i class="material-icons eye" v-if="show_password" @click="togglePassword()">visibility</i>
												<i class="material-icons eye" v-else @click="togglePassword()">visibility_off</i>
							
												<div v-for="(val, index) in errors.current_password" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
												</div>
											</div>      
											
											<div class="text-box" style="position: relative;">
												<p class="text-muted">New Password</p>
												<input class="form-control login_subtexts" type="text" placeholder="" v-model="new_password" v-if="show_password" v-bind:class="{ 'is-invalid': Boolean(errors.new_password && errors.new_password.length) }">
												<input class="form-control login_subtexts" type="password" placeholder="" v-model="new_password" v-else v-bind:class="{ 'is-invalid': Boolean(errors.new_password && errors.new_password.length) }">
												<i class="material-icons eye" v-if="show_password" @click="togglePassword()">visibility</i>
												<i class="material-icons eye" v-else @click="togglePassword()">visibility_off</i>

												<div v-for="(val, index) in errors.new_password" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
												</div>
											</div>
													 
											<div>
												<input type="button" value="Submit" @click="changePassword()" class="right mt-3">
											</div>
													 
										</div>
												
									</div>
								</div>
							</div>
						</div>
						<!-- end of #password-content -->

					</div>
				</div>
		  </div>
	 </div>
	 <b-modal id="location" title="Delivery Location" hide-footer @shown="panToMarker()">
			<form @submit.prevent="setLocation()">
				<b-input-group class="mt-3 input-location">
					<template #prepend>
						<b-input-group-text><img src="/design/sigofood-images/Deliver.png"></b-input-group-text>
					</template>
					<GmapAutocomplete @place_changed="setPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here to pick the required latitude and longitude..."  :value="location"/>
				</b-input-group>
				<GmapMap v-if="marker.position.lat && marker.position.lng"
				:center="center"
				:zoom="18"
				map-style-id="roadmap"
				:options="mapOptions"
				style="width: 100%; height: 300px"
				ref="mapRef">                              
					<GmapMarker
					:position="marker.position"
					:clickable="false"
					:draggable="false"                                    
					/>
				</GmapMap>   
				
				<div class="text-center">
					<b-button type="submit" class="mt-3 deliver-here px-5" @click="hideModal('location')">Deliver Here</b-button>
				</div>
			</form>
		</b-modal>


	
	</Layout>
</template>

<script>
	// @ is an alias to /src
import Layout from "@/layout/Main.vue";

export default {
	components: {
		Layout
	},

	data () {
		return {
		  	publicPath: process.env.BASE_URL,
		  	style: null,
		  	uid:'',
		  	token:'',
		  	device_token:'',
			is_add:false,
			is_edit:false,
			show_password: false,
		  	user: [],
			addresses: [],
			email: "",
			password: "",
			current_password: "",
			new_password: "",
			address:{
				area: '',
				flat: '',
				road_no: '',
				building_no: '',
				block: '',
				mobile: '',
				landmark: '',
				latitude: '',
				longitude: '',
			},		  

		  	marker: { position: { lat: null, lng: null } },
			center: { lat: null, lng: null },
			current_place: null,
			location: "",

			mapOptions: {
				disableDefaultUI: true,
			},
			center1:{lat: null, lng: null },
			locations:"",  
			errors: {},
		}
	},
	mounted() {
		this.fetchProfile();
		this.getAddress();
	},

	created() {
		this.style = document.createElement('link')
		this.style.setAttribute('rel', 'stylesheet')
		this.style.setAttribute('href', '/design/profile.css')
		document.head.appendChild(this.style)
		this.getToken();
	},

	beforeDestroy() {
		document.head.removeChild(this.style);
	},

	methods:{

		numbersOnly(event) {
			let keyCode = event.keyCode;
			if (keyCode < 48 || keyCode > 57) {
					event.preventDefault();
			}
		}, 

		alphaSpacesOnly(event) {
			let keyCode = event.keyCode;
			if ((keyCode >= 65 && keyCode <= 90) || 
				(keyCode >= 97 && keyCode <= 122) ||               
				(keyCode == 32)) {
				return;
			} else {
				event.preventDefault();
			}
		},

		togglePassword() {
			if(this.show_password == false) {
					this.show_password = true;
			} else {
					this.show_password = false;
			}
		},

		getToken() {
			if (localStorage.getItem('sigofood_user')) {
				var sigofood_user =  JSON.parse(localStorage.getItem('sigofood_user'));
				console.log(sigofood_user);
				if(sigofood_user.token) {
					this.token = sigofood_user.token;
					this.uid = sigofood_user.uid;
					this.user_id = sigofood_user.user_id;
					console.log(this.token);
					console.log(this.uid);
					console.log(this.user_id);

				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
				
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		}, 

		geolocate() {
			navigator.geolocation.getCurrentPosition((position) => {
				this.marker.position = {
					  lat: position.coords.latitude,
					  lng: position.coords.longitude,
				};
				this.center = {
					  lat: position.coords.latitude,
					  lng: position.coords.longitude,
				};
				
			});
		},

		//sets the position of marker when dragged
		handleMarkerDrag(e) {
			this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
		},

		//Moves the map view port to marker
		panToMarker() {
			console.log(this.marker.position);
			this.$refs.mapRef.panTo(this.marker.position);
			//this.$refs.mapRef.setZoom(18);
		},

		//Moves the marker to click position on the map
		handleMapClick(e) {
			this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
			console.log(e);
		},

		setPlace(place) {
			this.current_place = place;
			if(this.current_place) {
				const marker = {
					lat: this.current_place.geometry.location.lat(),
					lng: this.current_place.geometry.location.lng(),
				};
				this.center = marker;
				this.marker.position = marker;
				this.location = place.formatted_address;
				console.log(place);
			}
		},

		setLocation() {
			// this.location = {};
			this.address.latitude = this.marker.position.lat;
			this.address.longitude = this.marker.position.lng;
			// this.location.block_no = this.block_no;
			// localStorage.setItem('sigofood_location', JSON.stringify(this.location)); 
			// this.$router.push({ name: "home" });
			console.log(this.address.latitude); 
			console.log(this.address.longitude);
		},

		fetchProfile(){
			this.getToken();
			let url = "profile?uid=" +this.uid;
	
			this.loading = true;
				
			this.$axios
			.get(url, { headers: { Authorization: "Bearer " + this.token } })
			.then((res) => {
				if(res.status == 200) {
					var responseData = res.data.data;
					console.log(responseData);
					this.user = responseData;
				} else {
					this.$swal("", "Something went wrong", "error");
				}
			})
			.catch((error) => {
				if (error.response) {
					if(error.response.status == 422) {               
						if (error.response.data) {
							this.errors = error.response.data.message;
						} 
						this.$swal("", error.response.statusText, "error");
						 
					} else if(error.response.status == 500) {
						this.$swal("", error.response.statusText, "error");
	
					} else if(error.response.status == 401) {
						this.$swal("", error.response.statusText, "error");
						this.$router.push({ name: "login" });
						 
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				} else {
					this.$swal("", error.message, "error");
				}
			})
			.finally(() => (this.loading = false));
		},

		profileUpdate(){

			this.errors = {
				firstname: [],
				lastname: [],
				mobile: [],
			};

			let is_valid = true;
				
			if(this.user.firstname == '') {
				this.errors.firstname[0] = 'Please enter first name';
				is_valid = false;
			} 			

			if(this.user.lastname == '') {
				this.errors.lastname[0] = 'Please enter last name';
				is_valid = false;
			} 	

			if(this.user.mobile == '') {
				this.errors.mobile[0] = 'Please enter mobile';
				is_valid = false;
			} 					

			if (is_valid == true) {
				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
				};

				let url = "profile/update";          
				let formData = new FormData(); 
				formData.append("uid", this.uid);
				formData.append("firstname", this.user.firstname);
				formData.append("lastname", this.user.lastname);
				formData.append("mobile", this.user.mobile);

				this.$axios
				.post(url,formData, config)
				.then((res) => {
					if(res.status == 200) {
						this.$swal("", res.data.message, "success");        

					} else {
						this.$swal("", "Something went wrong", "error");
						console.log(this.error);
					}
						
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
								this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
								
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
								
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));
			}
		},

		getAddress() {
			// this.getToken();
			let url = "Address?uid=" +this.uid +"&device_token" +"";
	
			this.loading = true;
			this.$axios
			.get(url, { headers: { Authorization: "Bearer " + this.token } })
			.then((res) => {
				if(res.status == 200) {
					var responseData = res.data.data;
					console.log(responseData);
					this.addresses = responseData;
					// document.getElementById('tab_2').scrollIntoView({behavior:'smooth'});
					//  console.log(this.user);
				} else {
					this.$swal("", "Something went wrong", "error");
				}
			})
			.catch((error) => {
				if (error.response) {
					if(error.response.status == 422) {               
						if (error.response.data) {
							this.errors = error.response.data.message;
						} 
						this.$swal("", error.response.statusText, "error");
								
					} else if(error.response.status == 500) {
						this.$swal("", error.response.statusText, "error");

					} else if(error.response.status == 401) {
						this.$swal("", error.response.statusText, "error");
						this.$router.push({ name: "login" });
								
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				} else {
					this.$swal("", error.message, "error");
				}
			})
			.finally(() => (this.loading = false));
		},

		remove(address_id){

			const config = {
				headers: {
					"Content-type": "multipart/form-data",
					"Accept": "application/json",
					"Authorization": "Bearer " + this.token,
				},
			};

			let url = "address/deleteAddress";
			let formData = new FormData(); 
			formData.append("uid", this.uid);
			formData.append("address_id", address_id);

			this.$bvModal.msgBoxConfirm('Are you sure you want to delete this address?', {
					title: 'Confirm',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
			})
			.then(value => {
				if(value) {
					this.$axios
					.post(url,formData, config)
					.then((res) => {
						if(res.status == 200) {
							this.$swal("", res.data.message, "success");
							this.getAddress();

						} else {
							this.$swal("", "Something went wrong", "error");
							console.log(this.error);
						}
							
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
									this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
									
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");

							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
									
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));
				}
			})
			.catch(err => {
				console.log(err);
			})
		},

		changeEmail(){

			this.errors = {
				email: [],
				password: [],
			};

			let is_valid = true;
				
			if(this.email == '') {
				this.errors.email[0] = 'Please enter email';
				is_valid = false;
			} 			

			if(this.password == '') {
				this.errors.password[0] = 'Please enter your password';
				is_valid = false;
			} 	

			if (is_valid == true) {
				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
				};
				  
				let url = "profile/changeEmail";          
				let formData = new FormData(); 
				formData.append("uid", this.uid);
				formData.append("email", this.email);
				formData.append("password", this.password);

				this.$axios
				.post(url,formData, config)
				.then((res) => {
					if(res.status == 200) {
						this.$swal("", res.data.message, "success");        
						// document.getElementById('tab_1').scrollIntoView({behavior:'smooth'});
						this.$router.go(0);
					} else {
						this.$swal("", "Something went wrong", "error");
						console.log(this.error);
					}
							
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
								this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
									
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
									
						} else {
							this.$swal("", "Something went wrong", "error");
						}

					} else {
						this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));
			}
		},

		changePassword(){

			this.errors = {
				current_password: [],
				new_password: [],
			};

			let is_valid = true;
				
			if(this.current_password == '') {
				this.errors.current_password[0] = 'Please enter your current password';
				is_valid = false;
			} 			

			if(this.new_password == '') {
				this.errors.new_password[0] = 'Please enter your new password';
				is_valid = false;
			} 	

			if (is_valid == true) {
				const config = {
						headers: {
							"Content-type": "multipart/form-data",
							"Accept": "application/json",
							"Authorization": "Bearer " + this.token,
						},
				};
				  
				let url = "profile/changePassword";          
				let formData = new FormData(); 
				formData.append("uid", this.uid);
				formData.append("current_password", this.current_password);
				formData.append("new_password", this.new_password);

				this.$axios
				.post(url,formData, config)
				.then((res) => {
					if(res.status == 200) {
						this.$swal("", res.data.message, "success");        
						// document.getElementById('tab_1').scrollIntoView({behavior:'smooth'});
						this.$router.go(0);

					} else {
						this.$swal("", "Something went wrong", "error");
						console.log(this.error);
					}
							
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
								this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
									
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
									
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false)); 
			}
		},

		addAddress(){
			this.errors = {
					area: [],
					flat: [],
					road_no: [],
					building: [],
					block: [],
					mobile: [],
					//location: [],
					latitude: [],
					longitude: [],
			};

			let is_valid = true;
				
			if(this.address.area == '') {
				this.errors.area[0] = 'Please enter area';
				is_valid = false;
			} 
			if (this.address.flat == '') {
				this.errors.flat[0] = 'Please enter flat name';
				is_valid = false;
			} 
			if(this.address.road_no == '') {
				this.errors.road_no[0] = 'Please enter road number';
				is_valid = false;
			} 
			if (this.address.building == '') {
					this.errors.building[0] = 'Please enter building number';
					is_valid = false;
			} 
			if(this.address.block == '') {
					this.errors.block[0] = 'Please enter block';
					is_valid = false;
			} 
			if (this.address.mobile == '') {
					this.errors.mobile[0] = 'Please enter mobile number';
					is_valid = false;
			}

			if (this.address.latitude == '') {
					this.errors.latitude[0] = 'Please choose your location';
					is_valid = false;
			}
				
			if (this.address.longitude == '') {
					this.errors.longitude[0] = 'Please choose your location';
					is_valid = false;
			}

			if (is_valid == true) {
				alert('valid');
				console.log('address');
				console.log(this.address);

				// const config = {
				// 	headers: {
				// 		"Content-type": "multipart/form-data",
				// 		"Accept": "application/json",
				// 		"Authorization": "Bearer " + this.token,
				// 	},
				// };

				// let url = "address/add";
				// let formData = new FormData(); 
				// formData.append("uid", this.uid);
				// formData.append("device_token", this.device_token);
				// formData.append("area", this.address.area);
				// formData.append("flat", this.address.flat);
				// formData.append("road_no", this.address.road_no);
				// formData.append("building", this.address.building_no);
				// formData.append("block", this.address.block);
				// formData.append("mobile", this.address.mobile);
				// formData.append("landmark", this.address.landmark);
				// formData.append("latitude", this.address.latitude);
				// formData.append("longitude", this.address.longitude);
				// this.$axios
				// .post(url,formData, config)
				// .then((res) => {
				// 	if(res.status == 200) {
				// 		this.$swal("", res.data.message, "success");
				// 		this.clearForm();
				// 		this.getAddress();
				// 		this.$router.go(0);        
				// 		// document.getElementById('tab_1').scrollIntoView({behavior:'smooth'});
							
				// 	} else {
				// 		this.$swal("", "Something went wrong", "error");
				// 		console.log(this.error);
				// 	}
				// })
				// .catch((error) => {
				// 	if (error.response) {
				// 		if(error.response.status == 422) {               
				// 			if (error.response.data) {
				// 				this.errors = error.response.data.message;
				// 			} 
				// 			this.$swal("", error.response.statusText, "error");
									
				// 		} else if(error.response.status == 500) {
				// 			this.$swal("", error.response.statusText, "error");

				// 		} else if(error.response.status == 401) {
				// 			this.$swal("", error.response.statusText, "error");
				// 			this.$router.push({ name: "login" });
									
				// 		} else {
				// 			this.$swal("", "Something went wrong", "error");
				// 		}
				// 	} else {
				// 		this.$swal("", error.message, "error");
				// 	}
				// })
				// .finally(() => (this.loading = false));

			}
		},

		editAddress(){

			this.errors = {
					area: [],
					flat: [],
					road_no: [],
					building: [],
					block: [],
					mobile: [],
					//location: [],
					latitude: [],
					longitude: [],
			};

			let is_valid = true;
				
			if(this.address.area == '') {
				this.errors.area[0] = 'Please enter area';
				is_valid = false;
			} 
			if (this.address.flat == '') {
				this.errors.flat[0] = 'Please enter flat name';
				is_valid = false;
			} 
			if(this.address.road_no == '') {
				this.errors.road_no[0] = 'Please enter road number';
				is_valid = false;
			} 
			if (this.address.building == '') {
					this.errors.building[0] = 'Please enter building number';
					is_valid = false;
			} 
			if(this.address.block == '') {
					this.errors.block[0] = 'Please enter block';
					is_valid = false;
			} 
			if (this.address.mobile == '') {
					this.errors.mobile[0] = 'Please enter mobile number';
					is_valid = false;
			}

			if (this.address.latitude == '') {
					this.errors.latitude[0] = 'Please choose your location';
					is_valid = false;
			}
				
			if (this.address.longitude == '') {
					this.errors.longitude[0] = 'Please choose your location';
					is_valid = false;
			}

				

			if (is_valid == true) {
				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
				};

				let url = "address/updateAddress";
				let formData = new FormData(); 
				formData.append("uid", this.uid);
				formData.append("address_id", this.address.address_id);
				formData.append("area", this.address.area);
				formData.append("flat", this.address.flat);
				formData.append("road_no", this.address.road_no);
				formData.append("building", this.address.building_no);
				formData.append("block", this.address.block);
				formData.append("mobile", this.address.mobile);
				formData.append("landmark", this.address.landmark);
				formData.append("latitude", this.address.latitude);
				formData.append("longitude", this.address.longitude);

				this.$axios
				.post(url,formData, config)
				.then((res) => {
					if(res.status == 200) {
						this.$swal("", res.data.message, "success");
						this.clearForm();
						this.getAddress();
						this.$router.go(0);        
						// document.getElementById('tab_1').scrollIntoView({behavior:'smooth'});

					} else {
						this.$swal("", "Something went wrong", "error");
						console.log(this.error);
					}
							
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
								this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
									
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
									
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));
			}
		},

		hideModal(modal) {
			// this.$refs[modal].hide();
			this.$bvModal.hide(modal);
		},

		SetEditAddress(address){
			this.address.address_id = address.address_id;
			this.address.area = address.area;
			this.address.flat = address.flat;
			this.address.road_no = address.road_no;
			this.address.building_no = address.building_no;
			this.address.block = address.block;
			this.address.mobile = address.mobile;
			this.address.landmark = address.landmark;
			this.address.latitude = address.latitude;
			this.address.longitude = address.longitude;
		},

		clearForm() {        
			this.address.area = "";
			this.address.flat = "";
			this.address.road_no = "";
			this.address.building_no = "";
			this.address.block = "";
			this.address.mobile = "";
			this.address.landmark = "";
			this.address.latitude = "";
			this.address.longitude = "";
			this.errors = {};
			this.location = '';
			this.is_add = false;
			this.is_edit = false;
		},

	}
}
</script>
